<template>
  <el-dialog :visible.sync="exhibition" :custom-class="$i18n.locale === 'zh' ?'addUser' :'enAddUser'" :before-close="close">
    <div slot="title" class="el-dialog__title"><div class="title-left"></div><slot name="title">{{$t('managementV2.add')}}</slot><div class="title-right"></div></div>
    <el-form :model="form" :rules="rules" ref="form">

      <!-- 独立部署显示为邮箱 -->
      <el-form-item prop="phoneOrEmail" :label="$t('managementV2.phoneOrEmail')" v-if="HAVE_PHONE">
        <el-input v-model="form.phoneOrEmail" :placeholder="$t('managementV2.enterPhoneOrEmail')" maxlength="35"></el-input>
      </el-form-item>
      <el-form-item prop="email" :label="$t('managementV2.email')" v-else>
        <el-input v-model="form.email" :placeholder="$t('managementV2.enterEmail')" maxlength="35"></el-input>
      </el-form-item>

      <el-form-item prop="name" :label="$t('managementV2.name')">
        <el-input v-model.trim="form.name" :placeholder="$t('managementV2.pleaseinputName')"></el-input>
      </el-form-item>
      <el-form-item prop="role" :label="$t('managementV2.role')">
        <el-select v-model="form.role" :placeholder="$t('managementV2.pleaseselectRole')" @change="addChanged">
          <el-option v-for="item in roleId" :key="item.id" :label="$i18n.locale === 'zh' ? item.name : $roleCase[item.roleType]" :value="item.id"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item prop="authority" class="authoritybox" :label="$t('managementV2.jurisdiction')">
        <el-checkbox-group v-model="form.authority">
          <el-checkbox @change="checkChange(item.id)" :label="item.id" name="authority" v-for="item in AllResource" :key="item.id" :style="TEAM_DEFAULT_AUTH.includes(item.name)?'display:none;':''">{{ $i18n.locale === 'zh' ? item.name : item.nameEn }}</el-checkbox>
        </el-checkbox-group>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="close">{{$t('managementV2.cancel')}}</el-button>
      <el-button type="primary" @click="addSure">{{$t('managementV2.determine')}}</el-button>
    </div>
  </el-dialog>
</template>

<script>
import _ from 'lodash';
import { getRoleId, getAllResource } from "@/services/teamManagement.js";
import {EMAIL_REGEXP,MOBILE_REGEXP} from '@/utils/reg.js'
export default {
  name: "addUser",
  props: {
    exhibition: {
      type: Boolean,
    },
    roleId: {
      type: Array,
    },
  },
  data () {
    var userEmail = (rule, value, callback) => {
      
      if (!value) {
        // return callback(new Error(this.$t('managementV2.mailboxcannotEmpty')));
        return callback(new Error(this.$t('managementV2.enterEmail')));
      }
      if (!EMAIL_REGEXP.test(value)) {
        // return callback(new Error(this.$t('managementV2.emailAddress')));
        return callback(new Error(this.$t('managementV2.pleasecorrectEmails')));
      }
      callback();
    };
    var phoneOrEmail = (rule, value, callback) => {
      if (value && !EMAIL_REGEXP.test(value) && !MOBILE_REGEXP.test(value)) {
        callback(new Error(this.$t('managementV2.correctPhoneOrEmail')));
      } else {
        callback();
      }
    }
    var username = (rule, value, callback) => {
      if (value === "") {
        return callback(new Error(this.$t('project.nameTip')));
      } else if (value.length < 2) {
        callback(new Error(this.$t('managementV2.nameContainsMin')));
      } else if (value.length > 10) {
        callback(new Error(this.$t('managementV2.nameContainsMax')));
      }
      callback();
    };
    var role = (rule, value, callback) => {
      if (value === "") {
        return callback(new Error(this.$t('managementV2.pleaseselectRole')));
      }
      callback();
    };
    return {
      IS_PRIVATE: IS_PRIVATE,   // 是否独立部署
      IS_ONLINE_PRIVATE: IS_ONLINE_PRIVATE,
      TEAM_DEFAULT_AUTH: typeof TEAM_DEFAULT_AUTH === 'undefined'? [] : TEAM_DEFAULT_AUTH,
      HAVE_PHONE:HAVE_PHONE,
      form: {
        loginPhone: "",
        email: '',
        name: "",
        role: "",
        authority: [],
      },
      rules: {
        email: [{ required: true, validator: userEmail, trigger: "blur" }],
        phoneOrEmail: [{ required: true, validator: phoneOrEmail, trigger: "blur" }],
        name: [{ required: true, validator: username, trigger: "blur" }],
        role: [{ required: true, validator: role, trigger: "change" }],
        authority: [
          {
            type: "array",
            required: true,
            message: this.$t('managementV2.onePermission'),
            trigger: "change",
          },
        ],
      },
      AllResource: [],
      // memoryBank: [],
      // glossaryBank: [],
      // corpus: [],
    };
  },
  mounted() {
    this.getAllResources();
  },

  methods: {
    //记忆库，术语库，语料库 选择
    checkChange(value) {
      let check = this.AllResource.find(item => item.id === value);
      // 根节点
      if (check.level == 1 && check.parentId == 0) {
        let child = this.AllResource.filter(item => item.parentId == check.id && item.level == 2);
        // 勾选存在后，加入子集id
        if (this.form.authority.includes(check.id)) {
          child.forEach(item => {
            this.form.authority.push(item.id);
          });
        } else {
          // 不存在，删除所有子集
          this.form.authority = _.difference(this.form.authority, child.map(item => item.id));
        }
      }

      // 子集
      if (check.level == 2 && check.parentId !== 0) {
        // 勾选存在后，加入父级id
        if (this.form.authority.includes(check.id)) {
          if (!this.form.authority.includes(check.parentId)) {
            this.form.authority.push(check.parentId);
          }
        } else {
          // 找到同级，包括自己
          let child = this.AllResource.filter(item => item.parentId == check.parentId && item.level == 2);
          // 看数组里是不是没有了所有child，是的就删除父级id
          if (this.form.authority.length === _.difference(this.form.authority, child.map(item => item.id)).length) {
            this.form.authority = _.difference(this.form.authority, [check.parentId]);
          }
        }
      }
    },
    //获取全部资源
    async getAllResources() {
      const res = await getAllResource();
      console.log(res, '111')
      if (res.success && res.status == 200) {
        this.AllResource = res.result;
      }
    },
    close() {
      this.$emit("childByval");
      this.$refs.form.resetFields();
    },
    //角色切换
    async addChanged() {
      let params = {
        id: this.form.role,
        resType: 'CATWEB',
      };
      const { success, result } = await getRoleId(params);
      if (success) {
        // 拿到     CAT     菜单的权限
        // let arr = result.filter(item => item.resType === 'CATWEB').slice(0, 6);
        // this.form.authority = arr.map((item) => {
        //   return item.id;
        // });
        this.form.authority = result.map((item) => {
          return item.id;
        });
      }
    },
    //确定
    addSure() {
      this.$refs.form.validate((valid) => {
        if (!valid) return;
        if (this.form.authority.length == 0) {
          this.$message.closeAll();
          this.$message.warning(this.$t('managementV2.pleaseChoosejurisdiction'),);
          return;
        }
        let projectName = this.roleId.find(
          (val) => val.id == this.form.role
        ).name;
        let params = {
          name: this.form.name,
          id: this.form.authority,
          roleId: this.form.role,
          roleName: projectName,
        };
        const account = this.form.phoneOrEmail.trim();
        if (this.HAVE_PHONE && (EMAIL_REGEXP.test(account) || MOBILE_REGEXP.test(account))) {
          if (EMAIL_REGEXP.test(account)) {
            params.email = account;
          }
          if (MOBILE_REGEXP.test(account)) {
            params.loginPhone = account;
          }
        } else {
          params.email = this.form.email;
        }
        this.$emit("sendInvitationsMembers", params);
        this.$refs.form.resetFields()
      });
    },
  },
  watch: {
    roleId: {
      handler(val) {
        this.form.role = val[0].id;
        this.addChanged();
      },
      deep: true,
    },
  },
};
</script>

<style lang="less" scoped>
@import "./assets/style.less";
</style>
